module.exports = __webpack_public_path__ + "img/boissons-chaudes.7bc34a0e.svg";